import React, { ReactElement } from 'react';
// import styled from '@emotion/styled';

// import RatingStars from '../../images/HomePage/starsrating.svg';
// import RatingLogo from '../../images/HomePage/ratinglogo.svg';
import { JoinOpenLearning } from '../../components/Marketing/JoinOpenLearning';
import { TopBar } from '../../components/Marketing/TopBar';
import { HeroPartners } from './components/HeroPartners';
import { GlobalCommunity } from '../../components/Marketing/GlobalCommunity';
import { LeadingInstitutions } from '../../components/Marketing/LeadingInstitutions';
import { TheDifference } from './components/TheDifference';
import { AllInOne2 } from './components/AllInOne2';
import { EmpoweringInstitutions } from './components/EmpoweringInstitutions';
import { ASXListed } from './components/ASXListed';
import { DrivingBrand } from './components/DrivingBrand';
import { Scaling1 } from './components/Scaling1';
import { Scaling2 } from './components/Scaling2';
import { Footer } from '../../components/Marketing/Footer';
import { MarketingPageGlobalStyling } from '../../components/MarketingPageGlobalStyling/component';
import { PartnersListingPageProps } from './types';

// const RatingsCard = styled.div`
// display: flex;
//     position: fixed;
//     bottom: 25px;
//     right: 25px;
//     width: 226px;
//     background-color: white;
//     padding: 15px 20px;
//     background: #FFFFFF;
//     border-radius: 4px;
//     box-shadow: 0px 7px 12px rgba(0, 0, 0, 0.25);
//     width: 187px;
//     z-index: 50;
//     @media only screen and (max-width: 1101px) {
//       display: none;
//     }
// `;

// const RatingsCardInner = styled.div`
//     font-family: Avenir;
//     font-style: normal;
//     font-weight: bold;
//     font-size: 14px;
//     line-height: 180%;
//     display: block;
//     padding-left: 15px;
// `;

export const PartnersListingPage = ({
  isLoggedIn,
  localPartners,
  globalPartners,
}: PartnersListingPageProps): ReactElement => {
  return (
    <>
      <MarketingPageGlobalStyling />
      {isLoggedIn ? null : <TopBar />}
      <HeroPartners />
      <GlobalCommunity />
      <LeadingInstitutions
        title="We partner with the world’s most learner-centric education providers"
        logos={[...localPartners, ...globalPartners]}
      />
      <TheDifference />
      <AllInOne2 />
      <EmpoweringInstitutions />
      <ASXListed />
      <DrivingBrand />
      <Scaling1 />
      <Scaling2 />
      <JoinOpenLearning
        header="Ready to deliver a better experience for your learners?"
        buttonText="Enquire now"
        buttonAction={{
          kind: 'external_link',
          value: 'https://solutions.openlearning.com/contact/',
          target: '_blank',
        }}
      />
      {isLoggedIn ? null : <Footer />}
      {/* <RatingsCard>

      <img src={RatingLogo} alt="5 stars"  />
      <RatingsCardInner>
      Our happy students
      <img src={RatingStars} alt="5 stars"  />

      </RatingsCardInner>

      </RatingsCard> */}
    </>
  );
};
